import { Flex, useStyles, Caption, Image } from '@archipro-design/aria';
import type { RenderAnchorTag } from '../../types';
import * as S from './AppMenuReseneSponsor.style';
import type { SyntheticEvent } from 'react';
import { forwardRef } from 'react';

interface AppMenuReseneSponsorProps {
    assetsBaseUrl: string;
    renderAnchorTag: RenderAnchorTag;
    onClick?: (e: SyntheticEvent) => void;
}

export const AppMenuReseneSponsor = forwardRef<
    HTMLDivElement,
    AppMenuReseneSponsorProps
>((opt, ref) => {
    const { renderAnchorTag, onClick, assetsBaseUrl } = opt;
    const { css } = useStyles();

    return (
        <Flex column className={css(S.ReseneSponsor)}>
            <Caption
                variant={'01'}
                weight="medium"
                className={css(S.ReseneSponsorHeader)}
            >{`Sponsored by`}</Caption>
            <Flex
                ref={ref}
                className={css(S.ReseneSponsorLogo)}
                {...renderAnchorTag('/professional/resene')}
                onClick={onClick}
            >
                <Image
                    src={`${assetsBaseUrl}/assets/website/images/ui/megamenu_resene_logo_187.png`}
                    width={140}
                    height={54}
                    layout="responsive"
                    alt="Sponsored by Resene"
                    variables={{
                        placeholderBackgroundColorLight: 'transparent',
                    }}
                />
            </Flex>
        </Flex>
    );
});
